export const formatDecimals = (number) => {
  const scrubbed = number ? number.replace(/[^\d.-]/g, '') : '';
  const [integer, ...fractional] = scrubbed.split('.');
  return `${integer}${fractional.length ? `.${fractional.join('').substring(0, 2)}` : ''}`;
};
